'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/new-business/stage4/components/charity-donation-panel.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _updateFields = require('@marmalade/form/lib/actions/update-fields');
var _checkboxStacked = require('@marmalade/form/lib/components/checkbox/checkbox-stacked');
var _checkboxStacked2 = _interopRequireDefault(_checkboxStacked);
var _radio = require('@marmalade/form/lib/components/radio');
var _radio2 = _interopRequireDefault(_radio);
var _lib = require('@marmalade/message/lib/');
var _lib2 = _interopRequireDefault(_lib);
var _panel = require('@marmalade/panel');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reduxWindow = require('redux-window');
var _centrepointLogo = require('../../../../media/centrepoint-logo.png');
var _centrepointLogo2 = _interopRequireDefault(_centrepointLogo);
var _centrepointLogo_mobile = require('../../../../media/centrepoint-logo_mobile.png');
var _centrepointLogo_mobile2 = _interopRequireDefault(_centrepointLogo_mobile);
var _constants = require('../../constants');
var _charity = require('../../selectors/charity');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var formId = _constants.stages[3].formId;
var CharityDonationPanel = function (_Component) {
  _inherits(CharityDonationPanel, _Component);
  function CharityDonationPanel() {
    _classCallCheck(this, CharityDonationPanel);
    return _possibleConstructorReturn(this, (CharityDonationPanel.__proto__ || Object.getPrototypeOf(CharityDonationPanel)).apply(this, arguments));
  }
  _createClass(CharityDonationPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        lgScreen = _props.lgScreen,
        donation = _props.donation;
      var Element = lgScreen ? _panel.PanelAside : _panel.Panel;
      var giftAidDeclaration = 'Yes, I am happy for the gift of money that I have made to Centrepoint to be a Gift Aid donation. Centrepoint will reclaim 25p of tax on every £1 I give.';
      return _react2.default.createElement(Element, {
        className: 'cover-panel',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 32
        },
        __self: this
      }, _react2.default.createElement('h2', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33
        },
        __self: this
      }, 'Centrepoint charity donation'), _react2.default.createElement(LogoAndText, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34
        },
        __self: this
      }, _react2.default.createElement('img', {
        src: lgScreen ? _centrepointLogo2.default : _centrepointLogo_mobile2.default,
        alt: 'Centrepoint charity logo',
        width: '100%',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        },
        __self: this
      }), _react2.default.createElement('p', {
        style: {
          alignSelf: 'center'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36
        },
        __self: this
      }, 'Would you like to donate an additional ', _react2.default.createElement('strong', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37
        },
        __self: this
      }, '\xA31'), " towards Marmalade\u2019s chosen charity, Centrepoint, to help vulnerable young people move on from homelessness and build a future?")), _react2.default.createElement(DonationRadio, {
        name: 'donation',
        options: [{
          text: 'No thanks',
          value: 'false'
        }, {
          text: donation ? 'Donation added' : 'Donate £1',
          value: 'true'
        }],
        label: '',
        onChange: function onChange(value) {
          if (value === 'false') {
            _this2.props.setValue(formId, 'giftAid', []);
          }
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41
        },
        __self: this
      }), donation ? _react2.default.createElement(_react2.default.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 52
        },
        __self: this
      }, _react2.default.createElement('h3', {
        style: {
          fontSize: '20px'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53
        },
        __self: this
      }, 'Boost your donation by 25p of Gift Aid at no extra cost to you!'), _react2.default.createElement(_checkboxStacked2.default, {
        name: 'giftAid',
        options: [{
          text: giftAidDeclaration,
          value: 'true'
        }],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54
        },
        __self: this
      }), _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 58
        },
        __self: this
      }, 'Gift aid is claimed by Centrepoint from the tax you pay for the current tax year (income or capital gains tax). Please note that if you pay less tax in the current year that the amount of Gift Aid claimed on all your charity donations, it is your responsibility to pay the difference.', ' ', _react2.default.createElement('strong', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 62
        },
        __self: this
      }, 'Your full address is needed to identify you as a current UK taxpayer.'), ' Marmalade will provide centrepoint with your name and address in order to process your Gift Aid declaration.')) : null, _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 68
        },
        __self: this
      }, 'For more information about how Centrepoint will use your information, please see their', ' ', _react2.default.createElement('a', {
        href: 'https://centrepoint.org.uk/privacy-notice/',
        target: '_blank',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        },
        __self: this
      }, 'supporter privacy statement.')), _react2.default.createElement(RefundMessage, {
        type: 'warning',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72
        },
        __self: this
      }, 'Please note - your charity donation is non-refundable'));
    }
  }]);
  return CharityDonationPanel;
}(_react.Component);
CharityDonationPanel.propTypes = {
  lgScreen: _propTypes.bool.isRequired,
  donation: _propTypes.bool,
  setValue: _propTypes.func,
  theme: _propTypes.object
};
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    lgScreen: (0, _reduxWindow.getWidth)(state) >= 992,
    donation: (0, _charity.donation)(state)
  };
}, {
  setValue: _updateFields.setValue
})((0, _glamorous.withTheme)(CharityDonationPanel));
var DonationRadio = (0, _glamorous2.default)(_radio2.default)({
  width: '100%',
  textAlign: 'center',
  '@media screen and (min-width: 768px)': {
    width: '200px'
  }
});
var RefundMessage = (0, _glamorous2.default)(_lib2.default)({
  paddingBottom: '0'
});
var LogoAndText = _glamorous2.default.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
    marginBottom: '1em'
  }
});